import { createAction, createSlice } from '@reduxjs/toolkit';
import type { Dispatch } from 'redux';

import type { VehicleModel } from '../lib/types';
import { vehicleModelApi } from '../lib/api';
import { DELETE_VEHICLE_MODEL } from './vehicleModels';

export const FETCH_VEHICLE_MODEL = 'vehicles/model/fetch';
export const CLEAN_VEHICLE_MODEL = 'vehicles/model/clean';

export type VehicleModelState = VehicleModel | null;

const initialState: VehicleModelState = null;
const fetchVehicleModelAction = createAction<VehicleModel>(FETCH_VEHICLE_MODEL);
const cleanVehicleModelAction = createAction(CLEAN_VEHICLE_MODEL);

const vehicleModelSlice = createSlice({
  name: 'vehicles/model',
  initialState: initialState as VehicleModelState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchVehicleModelAction, (_state, { payload }) => payload)
      .addCase(cleanVehicleModelAction, () => initialState);
  }
});

export const vehicleModelActions = {
  fetch: fetchVehicleModelAction,
  clean: cleanVehicleModelAction
};

export const addVehicleModel = (model: VehicleModel) => async (
  dispatch: Dispatch
) => await vehicleModelApi.addVehicleModel(model);

export const deleteVehicleModel = (id: number) => async (
  dispatch: Dispatch
) => {
  await vehicleModelApi.deleteVehicleModel(id);
  dispatch({
    type: DELETE_VEHICLE_MODEL,
    payload: id
  });
};

export const updateVehicleModel = (model: VehicleModel) => async () => {
  await vehicleModelApi.updateVehicleModel(model);
};

export const fetchVehicleModel = (id: number) => async (dispatch: Dispatch) => {
  const model = await vehicleModelApi.fetchVehicleModel(id);
  dispatch(vehicleModelActions.fetch({ ...model }));
  return model;
};

export const cleanVehicleModel = () => async (dispatch: Dispatch) => {
  dispatch(vehicleModelActions.clean());
};

export default vehicleModelSlice.reducer;
